<template>
    <div class="wrapper" :style="commonStyle">
        <!---->
        <!--<h1>{{lang}}</h1>-->

        <div v-if="dataReady">
            <json-by-human v-if="renderJsonByHuman">
                <!-- <div v-if="false" class="contentWrapper"> -->
                <!-- 1 glossary -->
                <!-- 显示关闭 -->
                <!-- <cell-glossary :wrapData="glossary"></cell-glossary> -->

                <!-- 2 preface -->
                <cell-preface :wrapData="preface"></cell-preface>

                <!-- 3 content -->
                <cell-content :wrapData="content"></cell-content>
            </json-by-human>

            <html-by-docpe v-if="renderHtmlByDocpe">
                <div v-html="langPackHtml"></div>
            </html-by-docpe>

            <html-by-mammoth v-if="renderHtmlByMammoth">
                <div v-html="langPackHtml"></div>
            </html-by-mammoth>

            <p class="historyBtn" v-if="showHistoryBtn" @click="goListPage">
                {{ $t("common.history") }}
            </p>
        </div>
    </div>
</template>

<script>
// import world from '@/common/word';
import cellGlossary from "@/components/cell-glossary.vue";
import cellPreface from "@/components/cell-preface.vue";
import cellContent from "@/components/cell-content.vue";
import jsonByHuman from "@/pages/render/json-by-human.vue";
import htmlByDocpe from "@/pages/render/html-by-docpe.vue";
import htmlByMammoth from "@/pages/render/html-by-mammoth.vue";
import { mapState, mapMutations } from "vuex";
import * as utils from "@/utils";
let trace = new utils.Trace("首页", true);

export default {
    name: "home",
    components: {
        cellGlossary,
        cellPreface,
        cellContent,
        jsonByHuman,
        htmlByDocpe,
        htmlByMammoth
    },
    data() {
        return {
            langOption: [
                "ch",
                "cs",
                "da",
                "de",
                "el",
                "en",
                "es",
                "fi",
                "fr",
                "hk",
                "hu",
                "it",
                "jp",
                "kr",
                "nl",
                "pl",
                "pt",
                "ro",
                "ru",
                "sa",
                "se",
                "tr",
                "tw",
                "ua",
                "vn",
                "id",
                "th",
                "ua"
            ],
            versionOption: utils.CONST.privacy.versionOption,

            dataReady: false, // 数据是否准备好

            // world: {},              //

            // 语言数据
            langPack: {
                // glossary: { title: '123' } // 关闭显示
            },
            langPackHtml: null,

            // 定时器获取语言包
            count: 0, // 次数
            langInterval: null, // 获取语言吧定时器

            //
            msg: "Welcome to Your Vue.js App",
            showHistoryBtn: true
        };
    },
    computed: {
        ...mapState(["lang", "version"]),
        // 名词解释
        // 关闭显示
        // glossary() {
        //     return this.langPack.glossary || {}
        // },
        // 前言
        preface() {
            return this.langPack.preface || {};
        },
        // 内容
        content() {
            return this.langPack.content || {};
        },
        commonStyle() {
            if (this.lang === "sa") {
                return {
                    direction: "rtl",
                    "unicode-bidi": "bidi-override"
                };
            }
        },
        privacyVersion() {
            return utils.CONST.privacy.versionMap[this.version] || {};
        },
        renderJsonByHuman() {
            return (
                this.privacyVersion.renderTemplate ===
                utils.CONST.privacy.RENDER_TEMPLATE_ENUM.JSON_BY_HUMAN
            );
        },
        renderHtmlByDocpe() {
            return (
                this.privacyVersion.renderTemplate ===
                utils.CONST.privacy.RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE
            );
        },
        renderHtmlByMammoth() {
            return (
                this.privacyVersion.renderTemplate ===
                utils.CONST.privacy.RENDER_TEMPLATE_ENUM.HTML_BY_MAMMOTH
            );
        }
    },
    methods: {
        ...mapMutations(["setLang", "setVersion"]),
        // init
        async init() {
            try {
                await this.getLocalLang();
                await this.$nextTick();
                this.dataReady = true;
            } catch (err) {
                console.log(err);
                if (this.lang !== "en") {
                    // this.lang = "en";
                    this.setLang({ lang: "en", i18n: this.$i18n });
                    await this.getLocalLang();
                    await this.$nextTick();
                    this.dataReady = true;
                }
            }
        },
        // 获取本地语言包
        getLocalLangPack(url) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get(url)
                    .then(res => {
                        // 获取到了语言包，处理逻辑
                        // console.log(`This language pack: ${this.lang} Founded`);
                        // console.log(res.data)
                        // console.log(typeof res.data)
                        resolve(res.data);
                    })
                    .catch(error => {
                        // 获取不到语言包，则使用默认
                        // console.log(`This language pack: ${this.lang} unsupported`);
                        reject(error);
                    });
            });
        },
        // URL中获取参数
        getUrlParam(name) {
            let query = window.location.search.substring(1);
            let param_arr = query.split("&");
            for (let i = 0; i < param_arr.length; i++) {
                let pair = param_arr[i].split("=");
                if (pair[0] == name) {
                    return pair[1];
                }
            }
            return null;
        },
        async getLocalLang() {
            switch (this.privacyVersion.renderTemplate) {
                case utils.CONST.privacy.RENDER_TEMPLATE_ENUM.JSON_BY_HUMAN:
                    {
                        let url = `./static/langPack/${this.version}/${this.lang}.json`; // 补齐版本号 json名称
                        trace("获取文件的路径:", url);
                        this.langPack = await this.getLocalLangPack(url);
                    }
                    break;

                case utils.CONST.privacy.RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE:
                case utils.CONST.privacy.RENDER_TEMPLATE_ENUM.HTML_BY_MAMMOTH:
                    {
                        let url = `./static/langPack/${this.version}/${this.lang}.html`; // 补齐版本号 json名称
                        trace("获取文件的路径:", url);
                        this.langPackHtml = await this.getLocalLangPack(url);
                    }
                    break;

                default:
                    break;
            }
        },
        goListPage() {
            this.$router.push({
                name: "listPage"
            });
        }
    },
    // beforeRouteEnter(to, from, next) {
    //     next(vm => {
    //         const reload = vm.getUrlParam("reload");
    //         trace("是否需要刷新", reload);

    //         //! 需要刷新，肯定是通过版本列表进入的
    //         if (reload == "true") {
    //             vm.$router.replace({
    //                 name: "detailPage",
    //                 query: {
    //                     lang: vm.getUrlParam("lang"), //语言不变
    //                     version: vm.getUrlParam("version"), //版本不变
    //                     show: vm.getUrlParam("show"), //底部按钮是否显示不变
    //                     reload: false //!刷新肯定要关闭
    //                 }
    //             });
    //             vm.$router.go(0);
    //         }
    //     });
    // },
    created() {
        trace("编译的环境", process.env);

        let lang = (this.getUrlParam("lang") || "en").toLowerCase(); //!从参数中获取语言，若没法获取,强制为 en
        if (!this.langOption.includes(lang)) {
            lang = "en";
            trace("不支持该语言， 强制英语");
        }
        this.setLang({ lang, i18n: this.$i18n });
        trace(`语言:${this.lang}`);

        let version = (
            this.getUrlParam("version") || utils.CONST.privacy.defaultVersion
        ).toLowerCase(); //!从参数中获取版本，若没法获取，就用配置中默认的版本
        if (!this.versionOption.includes(version)) {
            version = this.versionOption[
                Math.max(this.versionOption.length - 1, 0)
            ];
            trace("不支持该版本未,用最后一个");
        }
        this.setVersion(version);
        trace(`版本:${this.version}`);
        trace("当前的版本信息:", this.privacyVersion);
        trace(`渲染模板的方式:${this.privacyVersion.renderTemplate}`);
        trace("版本列表:", this.versionOption);

        this.showHistoryBtn =
            this.getUrlParam("show") === "false" ? false : true;
        trace(`是否显示历史版本:${this.showHistoryBtn}`);

        this.init();
    }
};
</script>

<style lang="less">
.wrapper {
    .historyBtn {
        /* position: absolute;
        top: 0px; */

        font-size: 18px;
        width: 200px;
        height: 60px;
        color: #1a63e0;
        line-height: 60px;

        // border: 1px solid red;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue